/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_PtoInputs */

const en_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra PTO / vacation days`)
};

const de_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusätzliche Urlaubstage`)
};

const fr_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jours de congé supplémentaires`)
};

const es_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Días de vacaciones adicionales`)
};

const it_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorni di ferie extra`)
};

const nl_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra vakantiedagen`)
};

const pl_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodatkowe dni urlopowe`)
};

const fi_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisälomapäivät`)
};

const da_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstra feriedage`)
};

const sv_salary_negotiate_other_pto = /** @type {(inputs: Salary_Negotiate_Other_PtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra semesterdagar`)
};

/**
* | output |
* | --- |
* | "Extra PTO / vacation days" |
*
* @param {Salary_Negotiate_Other_PtoInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_pto = /** @type {((inputs?: Salary_Negotiate_Other_PtoInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_PtoInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_pto(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_pto(inputs)
	if (locale === "es") return es_salary_negotiate_other_pto(inputs)
	if (locale === "it") return it_salary_negotiate_other_pto(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_pto(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_pto(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_pto(inputs)
	if (locale === "da") return da_salary_negotiate_other_pto(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_pto(inputs)
	return en_salary_negotiate_other_pto(inputs)
});